import React from 'react';
import styles from './SharedGraphs.module.css';
import { useTranslation } from 'react-i18next';
import ListPicker from '../Shared/ListPicker';
import { useSize } from '../../hooks/useSize';

function SensorToGraphPicker({ sensors, onSensorClicked, selectedSensor }) {
  const { t } = useTranslation();
  const smallScreen = useSize();

  return smallScreen ? (
    <ListPicker
      options={sensors.map((sensor) => sensor.name)}
      setSelected={(name) =>
        onSensorClicked(sensors.find((sensor) => sensor.name === name))
      }
      selected={selectedSensor.name}
    />
  ) : (
    <div className={styles.sensorsToGraphContainer}>
      {sensors.map((sensor) => (
        <button
          key={sensor.name}
          onClick={() => onSensorClicked(sensor)}
          className={
            selectedSensor.name === sensor.name
              ? styles.selectedSensorToGraph
              : styles.sensorToGraph
          }
        >
          <p className={styles.sensorToGraphText}>{t(sensor.name)}</p>
        </button>
      ))}
    </div>
  );
}

export default SensorToGraphPicker;
